module.exports = "/lucky-balls/img/jackpot/014.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/jackpot/014.png
// module id = 1114
// module chunks = 0